// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-containers {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
  padding: 20px;
  margin-top: 4rem;
  margin-bottom: 15px;
}

.box {
  width: 180px;
  min-width: 180px;
  text-align: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 12px;
  background: #f5f5f5;
  transition: transform 0.2s;
  height: 180px;
}

.box:hover {
  transform: scale(1.05);
}

.service-image {
  width: 100%;
  height: 110px;
  object-fit: cover;
  border-radius: 10px;
}



.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.service-form-overlay {
  background: #fff;
  padding: 15px;
  border-radius: 10px;
  width: 360px;
  max-width: 92vw;
  max-height: 85vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.service-form-overlay h2 {
  font-size: 18px;
  margin-bottom: 5px;
}


.form-row {
  display: flex;
  gap: 12px;
}

.form-col {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.form-full {
  width: 100%;
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 13px;
}

/* Inputs */
input,
select,
textarea {
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 12px;
  width: 100%;
  box-sizing: border-box;
}

textarea {
  height: 80px;
  resize: none;
}


.day-image-row {
  display: flex;
  gap: 12px;
}

.day-box,
.image-box {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}


.upload-box {
  width: 100%;
  height: 80px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}


.upload-box input[type="file"] {
  display: none;
}

.upload-placeholder {
  font-size: 12px;
  color: #888;
}


.upload-preview {
  width: 50%;
  height: 100%;
  object-fit: cover;
  position: absolute;

}


.btn {
  width: 100%;
  padding: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn:hover {
  background: #0056b3;
}


/* @media (max-width: 1024px) {
  .box {
    width: calc(33.33% - 14px);
  }
} */


@media (max-width: 768px) {

  .form-row,
  .day-image-row {
    flex-direction: column;
  }

  .box {
    width: calc(50% - 10px);
  }
}


@media (max-width: 480px) {
  .box {
    width: 100%;
  }

  .service-form-overlay {
    width: 100%;
    padding: 12px;
    gap: 8px;
  }

  .btn {
    padding: 9px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Services/servicePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;;;AAIA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;;;EAGE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;;AAEpB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;;;GAIG;;;AAGH;;EAEE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF;;;AAGA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".main-containers {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: flex-start;\n  padding: 20px;\n  margin-top: 4rem;\n  margin-bottom: 15px;\n}\n\n.box {\n  width: 180px;\n  min-width: 180px;\n  text-align: center;\n  cursor: pointer;\n  padding: 10px;\n  border-radius: 12px;\n  background: #f5f5f5;\n  transition: transform 0.2s;\n  height: 180px;\n}\n\n.box:hover {\n  transform: scale(1.05);\n}\n\n.service-image {\n  width: 100%;\n  height: 110px;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 10000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n}\n\n.service-form-overlay {\n  background: #fff;\n  padding: 15px;\n  border-radius: 10px;\n  width: 360px;\n  max-width: 92vw;\n  max-height: 85vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.service-form-overlay h2 {\n  font-size: 18px;\n  margin-bottom: 5px;\n}\n\n\n.form-row {\n  display: flex;\n  gap: 12px;\n}\n\n.form-col {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.form-full {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\nlabel {\n  margin-bottom: 4px;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n/* Inputs */\ninput,\nselect,\ntextarea {\n  padding: 8px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\ntextarea {\n  height: 80px;\n  resize: none;\n}\n\n\n.day-image-row {\n  display: flex;\n  gap: 12px;\n}\n\n.day-box,\n.image-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n\n.upload-box {\n  width: 100%;\n  height: 80px;\n  border: 1px dashed #ccc;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n\n.upload-box input[type=\"file\"] {\n  display: none;\n}\n\n.upload-placeholder {\n  font-size: 12px;\n  color: #888;\n}\n\n\n.upload-preview {\n  width: 50%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n\n}\n\n\n.btn {\n  width: 100%;\n  padding: 10px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.btn:hover {\n  background: #0056b3;\n}\n\n\n/* @media (max-width: 1024px) {\n  .box {\n    width: calc(33.33% - 14px);\n  }\n} */\n\n\n@media (max-width: 768px) {\n\n  .form-row,\n  .day-image-row {\n    flex-direction: column;\n  }\n\n  .box {\n    width: calc(50% - 10px);\n  }\n}\n\n\n@media (max-width: 480px) {\n  .box {\n    width: 100%;\n  }\n\n  .service-form-overlay {\n    width: 100%;\n    padding: 12px;\n    gap: 8px;\n  }\n\n  .btn {\n    padding: 9px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
